"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'playerNative';
exports.SET_IS_FULL_SCREEN = exports.namespace + "/SET_IS_FULL_SCREEN";
exports.SET_IS_CHROMECAST_DEVICES_VISIBLE = exports.namespace + "/SET_IS_CHROMECAST_DEVICES_VISIBLE";
exports.SET_RESTRICTED_MESSAGE = exports.namespace + "/SET_RESTRICTED_MESSAGE";
exports.SET_LAST_CHECKED_CONTENT = exports.namespace + "/SET_LAST_CHECKED_CONTENT";
exports.SET_PLAYER_STATE = exports.namespace + "/SET_PLAYER_STATE";
exports.RESET_PLAYER_STATE = exports.namespace + "/RESET_PLAYER_STATE";
//# sourceMappingURL=constants.js.map